import { render, staticRenderFns } from "./ead-avaliacao.vue?vue&type=template&id=0bd83c7e&scoped=true&"
import script from "./ead-avaliacao.vue?vue&type=script&lang=js&"
export * from "./ead-avaliacao.vue?vue&type=script&lang=js&"
import style0 from "./ead-avaliacao.vue?vue&type=style&index=0&id=0bd83c7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd83c7e",
  null
  
)

export default component.exports